export const paymentMethods = {
  Cash: 'shifts.paymentMethodCash',
  CC: 'shifts.paymentMethodCard',
  Evoucher: 'shifts.paymentMethodEVoucher',
  BACS: 'shifts.paymentMethodBACS',
  BAF: 'shifts.paymentMethodBusinessAccount',
  Blue_Voucher: 'shifts.paymentMethodBlueVoucher',
  Loyalty_Points: 'shifts.paymentMethodLoyalty',
  Social_Media: 'shifts.paymentMethodSocialMedia',
  Writeoff: 'shifts.paymentMethodWriteOff',
  Paper_Voucher: 'shifts.paymentMethodPaperVoucher'
};
